import { devtoolsToggleAtom, isDev } from '@capsicum/common';
import { useAtom } from 'jotai';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const DevtoolContent = isDev() ? dynamic(() => import('./DevToolContent')) : () => null;

export const DevTool = () => {
	const [isVisible, setIsVisible] = useAtom(devtoolsToggleAtom);

	// Listen for ctrl + d to toggle devtool
	useEffect(() => {
		const onKeyDown = (e: KeyboardEvent) => {
			if (isVisible && e.code === 'Escape') setIsVisible(false);
			if (!isVisible && e.ctrlKey && e.code === 'KeyD' && isDev()) setIsVisible(true);
		};

		window.addEventListener('keydown', onKeyDown);

		return () => {
			window.removeEventListener('keydown', onKeyDown);
		};
	}, [isVisible, setIsVisible]);

	return isVisible ? <DevtoolContent onClose={() => setIsVisible(false)} /> : null;
};
